import * as types from 'store/actions/types';
import services from 'services/services';

// Import helpers
import { getErrorCodeResults, CUSTOM_ERROR } from 'helpers/error_code_api';

// ******************** SEND RESET EMAIL ********************
export const sendResetEmail = (email) => async (dispatch) => {
	try {
		dispatch({
			type: types.SEND_RESET_EMAIL_LOADING
		});

		const url = '/resetPassword/init';
		await services.post(url, email);

		dispatch({
			type: types.SEND_RESET_EMAIL_SUCCESS
		});
	} catch (error) {
		if (error.response) {
			const { codeErrorMessage } = getErrorCodeResults(error);
			// Dispatch an error action
			error.response.data.message = codeErrorMessage;
		}

		dispatch({
			type: types.SEND_RESET_EMAIL_ERROR,
			payload: error.response
		});

		throw error;
	}
};

// ******************** CHECK RESET PASSWORD HASH ********************
export const checkResetPasswordHash = (hash) => async (dispatch) => {
	try {
		dispatch({
			type: types.CHECK_RESET_PASSWORD_HASH_LOADING
		});

		const url = `/resetPassword/${hash}/checkStatus`;
		await services.post(url);

		dispatch({
			type: types.CHECK_RESET_PASSWORD_HASH_SUCCESS
		});
	} catch (error) {
		// add custom error message
		error.response.data.message = CUSTOM_ERROR.CHECK_HASH_CUSTOM_CODE;

		dispatch({
			type: types.CHECK_RESET_PASSWORD_HASH_ERROR,
			payload: error.response
		});
	}
};

// ******************** SEND NEW PASSWORDS ********************
export const sendNewPasswords = (passwords, hash) => async (dispatch) => {
	try {
		dispatch({
			type: types.SEND_NEW_PASSWORDS_LOADING
		});

		const url = `/resetPassword/${hash}`;
		await services.post(url, passwords);

		dispatch({
			type: types.SEND_NEW_PASSWORDS_SUCCESS
		});
	} catch (error) {
		if (error.response) {
			const { codeErrorMessage } = getErrorCodeResults(error);
			// Dispatch an error action
			error.response.data.message = codeErrorMessage;
		}

		dispatch({
			type: types.SEND_NEW_PASSWORDS_ERROR,
			payload: error.response
		});

		throw error;
	}
};

// ------------ Clear state ------------
export const clearResetPasswordState = () => (dispatch) => {
	dispatch({
		type: types.CLEAR_RESET_PASSWORD_STATE
	});
};
